import { gsap } from 'gsap'

export function header(element: HTMLElement): void {
  const menuButton = element.querySelector('.header__button')
  const closeButton = element.querySelector('.header__close')
  const menu = element.querySelector('.nav-primary')
  const parentLinks = element.querySelectorAll('.menu-item-has-children > a')
  const background = element.querySelector('.background')

  let lastScroll = 0
  const scrollDown = 'scroll-down'
  const scrollUp = 'scroll-up'

  window.addEventListener('scroll', () => {
    const currentScroll = window.pageYOffset
    if (currentScroll <= 0) {
      element.classList.remove(scrollDown)
      element.classList.remove(scrollUp)
      return
    }
    if (currentScroll > lastScroll && !element.classList.contains(scrollDown)) {
      // down
      element.classList.add(scrollDown)
      element.classList.remove(scrollUp)
    } else if (currentScroll < lastScroll && element.classList.contains(scrollDown)) {
      // up
      element.classList.remove(scrollDown)
      element.classList.add(scrollUp)
    }
    lastScroll = currentScroll
  })

  const checkScroll = (coords: any[], header: HTMLElement | null, color: string | 'dark') => {
    const scrollPosition = window.scrollY

    coords.forEach(coord => {
      if (scrollPosition >= coord.top && scrollPosition <= coord.bottom - 80) {
        header.classList.add(color);
      } else {
        header.classList.remove(color);
      }
    })
  };

  const darkBackground = document.querySelectorAll<HTMLElement>('.background-mid-green, .background-green-mid, .background-turquoise')
  const coords: { top: any; bottom: any }[] = []
  const header = document.querySelector('header')

  if (darkBackground.length > 0) {
    ;[...darkBackground].forEach(item => {
      const rect = item.getBoundingClientRect()

      coords.push({
        top: rect.top + window.scrollY,
        bottom: rect.bottom + window.scrollY
      })
    })

    checkScroll(coords, header, 'dark')

    window.addEventListener('scroll', () => {
      checkScroll(coords, header, 'dark')
    })
  }

  const lightBackground = document.querySelectorAll<HTMLElement>('.background-yellow')

  if (lightBackground.length > 0) {
    ;[...lightBackground].forEach(item => {
      const rect = item.getBoundingClientRect()

      coords.push({
        top: rect.top + window.scrollY,
        bottom: rect.bottom + window.scrollY
      })
    })

    checkScroll(coords, header, 'light')

    window.addEventListener('scroll', () => {
      checkScroll(coords, header, 'light')
    })
  }

  menuButton.addEventListener('click', e => {
    element.classList.add('dark')
    element.classList.add('active')

    gsap.to(background, {
      autoAlpha: 1,
      duration: 0.3,
      ease: 'power2.inOut'
    })

    gsap.to(menu, {
      autoAlpha: 1,
      duration: 0.3,
      ease: 'power2.inOut'
    })
  })

  closeButton.addEventListener('click', e => {
    element.classList.remove('dark')
    element.classList.remove('active')

    gsap.to(background, {
      autoAlpha: 0,
      duration: 0.3,
      ease: 'power2.inOut'
    })

    gsap.to(menu, {
      autoAlpha: 0,
      duration: 0.3,
      ease: 'power2.inOut'
    })

    checkScroll(coords, header)
  })
  ;[...parentLinks].forEach(el => {
    el.addEventListener('click', e => {
      e.preventDefault()
      const parent = el.parentNode
      const submenu = parent.querySelector('.sub-menu')
      const openMenu = element.querySelector('.active')

      const currentMenu = parent.classList.contains('active')

      if (openMenu) {
        const openSubmenu = openMenu.querySelector('.sub-menu')

        element.classList.remove('dark-active')
        element.classList.remove('active')

        const t1 = gsap.timeline();

        t1.to(background, {
          autoAlpha: 0,
          duration: 0.3,
          ease: 'power2.inOut'
        }, 'start')

        t1.to(openSubmenu, {
          autoAlpha: 0,
          duration: 0.3,
          ease: 'power2.inOut'
        }, 'start')

        openMenu.classList.remove('active')
        document.body.classList.remove('menu-active')
      }

      if (!currentMenu) {
        element.classList.add('dark-active')
        element.classList.add('active')

        gsap.to(background, {
          autoAlpha: 1,
          duration: 0.3,
          ease: 'power2.inOut'
        })

        gsap.to(submenu, {
          autoAlpha: 1,
          duration: 0.3,
          ease: 'power2.inOut'
        })

        parent.classList.add('active')
        document.body.classList.add('menu-active')
      }
    })
  })
}
